import consumer from "./consumer";
import sweet_alert from "../utilities/sweet_alert";

class ContractStatusChannel {
  static init() {
    this.cable = consumer.subscriptions.create({ channel: 'ContractStatusChannel', contract_job_user: `contract_job_${Traus.company.user.email}` }, {
      received: (data) => {
        if (!data || !data.redirect_to)
          return;

        sweet_alert.fire({
          title: 'Pronto',
          icon: 'success',
          text: `Contrato do aluno ${data.student_name}, foi anexado com sucesso. Deseja ser redirecionado para a matrícula?`,
          showClass: { backdrop: 'swal2-noanimation', popup: '', },
          hideClass: { popup: '' },
          customClass: {
            cancelButton: 'btn btn-gray-primary',
            confirmButton: 'btn btn-primary mr-3'
          },
          buttonsStyling: false,
          showCancelButton: true,
          focusConfirm: true,
          confirmButtonText: 'Ver Matrícula',
          cancelButtonText: 'Fechar'
        }).then((result) => {
          if (result.value) {
            window.location.href = data.redirect_to;
          }
        });

      }
    });
  }
}

$(() => ContractStatusChannel.init());